<span
  *ngIf="festiveService.festival$ | async as festival"
  class="festive-doodle festive-doodle--{{ size }}"
  role="img"
  [attr.aria-label]="festival.greeting"
  [attr.title]="festival.greeting"
>
  <svg viewBox="0 0 48 40" aria-hidden="true" focusable="false">
    <defs>
      <radialGradient [attr.id]="uid + '-glow'">
        <stop offset="0" stop-color="#FFD166" stop-opacity="0.75" />
        <stop offset="1" stop-color="#FFD166" stop-opacity="0" />
      </radialGradient>
      <linearGradient [attr.id]="uid + '-flame'" x1="0" y1="1" x2="0" y2="0">
        <stop offset="0" stop-color="#FF5A1F" />
        <stop offset="0.55" stop-color="#FF9F1C" />
        <stop offset="1" stop-color="#FFD166" />
      </linearGradient>
      <linearGradient [attr.id]="uid + '-bowl'" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stop-color="#C2410C" />
        <stop offset="1" stop-color="#8B1E3F" />
      </linearGradient>
    </defs>

    <!-- Rangoli dots -->
    <g class="festive-doodle__rangoli">
      <circle cx="8" cy="37" r="1.3" fill="#F59E0B" />
      <circle cx="14" cy="37.6" r="1.3" fill="#E11D74" />
      <circle cx="20" cy="38" r="1.3" fill="#F59E0B" />
      <circle cx="24" cy="37.6" r="1.8" fill="#FF7A1A" />
      <circle cx="28" cy="38" r="1.3" fill="#F59E0B" />
      <circle cx="34" cy="37.6" r="1.3" fill="#E11D74" />
      <circle cx="40" cy="37" r="1.3" fill="#F59E0B" />
    </g>

    <!-- Diya -->
    <circle class="festive-doodle__glow" cx="24" cy="12" r="11" [attr.fill]="url('glow')" />
    <g class="festive-doodle__flame">
      <path
        d="M24 3C27.5 8 29 12 27.6 15.6C26.8 17.6 25.4 18.6 24 18.6C22.6 18.6 21.2 17.6 20.4 15.6C19 12 20.5 8 24 3Z"
        [attr.fill]="url('flame')"
      />
      <path
        d="M24 9C25.6 11.5 26.2 13.6 25.5 15.4C25.1 16.4 24.6 16.9 24 16.9C23.4 16.9 22.9 16.4 22.5 15.4C21.8 13.6 22.4 11.5 24 9Z"
        fill="#FFF6D5"
      />
    </g>
    <rect x="23.5" y="17.6" width="1" height="2.6" rx="0.5" fill="#5B2A12" />
    <path
      d="M9 20.5C9 20.5 16 21.6 24 21.6C32 21.6 39 20.5 39 20.5C38 28 32 31.5 24 31.5C16 31.5 10 28 9 20.5Z"
      [attr.fill]="url('bowl')"
    />
    <ellipse cx="24" cy="20.8" rx="15" ry="2.2" fill="#D4A017" />
    <ellipse cx="24" cy="20.6" rx="12.5" ry="1.2" fill="#6B2A0F" />
    <circle cx="16" cy="25.6" r="1.1" fill="#F5C542" />
    <circle cx="24" cy="27" r="1.1" fill="#F5C542" />
    <circle cx="32" cy="25.6" r="1.1" fill="#F5C542" />
    <path d="M19 31H29L27.5 34H20.5Z" fill="#7A1A35" />

    <!-- Sparkles -->
    <g class="festive-doodle__sparkles" fill="#F5B301">
      <path class="festive-doodle__sparkle" d="M7 6L7.8 8.2L10 9L7.8 9.8L7 12L6.2 9.8L4 9L6.2 8.2Z" />
      <path class="festive-doodle__sparkle" d="M41 4L41.6 5.9L43.5 6.5L41.6 7.1L41 9L40.4 7.1L38.5 6.5L40.4 5.9Z" />
      <path class="festive-doodle__sparkle" d="M44 16L44.5 17.5L46 18L44.5 18.5L44 20L43.5 18.5L42 18L43.5 17.5Z" />
    </g>
  </svg>
</span>
